<template>
    <div>
        <router-link :to="{ name: 'shared.messages' }" class="tw-flex tw-items-center tw-justify-start tw-w-[40px] tw-h-[40px] tw-text-primary-950 hover:tw-text-primary-600 tw-duration-200">
            <icon icon="solar:chat-round-call-linear" class="tw-text-2xl" />
        </router-link>
    
    </div>
</template>

<script setup>

</script>

<style scoped></style>